import { Alert } from 'components/ui';
import styled from 'styled-components';
import theme from 'theme';

export const InfoAlert = styled(Alert)`
  margin-top: ${theme.padding.small};
  margin-bottom: ${theme.padding.content};
  margin-left: 0;
  justify-content: center;
  background: none;
  padding: 0;
`;
